import { selectEntriesRowsByPage } from 'store/data/entries';
import { useSelector } from 'hooks/utils';

export function useIsEntryPageFetched(pageIndex: number): boolean | null {
	const page = useSelector(state => selectEntriesRowsByPage(state.data.entries, pageIndex));

	return page ? page.length > 0 : null;
}
